<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="structure-nxt"> </p>
<p class="body-paragraph-white-center"><span class="CharOverride-1">Also by </span><span class="CharOverride-2">June Cotner</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Amazing Graces</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Animal Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Baby Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Back to Joy</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Bedside Prayers</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Bless the Beasts</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Bless the Day</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Christmas Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Comfort Prayers</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Dog Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Earth Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Family Celebrations</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Forever in Love</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Garden Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Get Well Wishes</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Graces</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Gratitude Prayers</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Heal Your Soul, Heal the World</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">The Home Design Handbook</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">House Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Looking for God in All the Right Places</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Miracles of Motherhood</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Mothers and Daughters</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Pocket Prayers</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Say a Little Prayer: A Journal</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Serenity Prayers</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Soar! Follow Your Dreams</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Teen Sunshine Reflections</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Toasts: The Perfect Words for Every Occasion</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">To Have and to Hold</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">We Are Women</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Wedding Blessings</span></p>
<p class="body-paragraph-GRAY ParaOverride-1"><span class="BROTHERregularitalic CharOverride-3">Wishing You Well</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781642503944.vue?4257ea9b